<template>
  <right-menu-item
    @click.prevent="click"
    :class="{'muted': !show}"
    :text="$t('Call for approval')"
    icon="email"
    icon-class=""
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
import Toast from '@/frontapp/mixins/actions/Toast'

export default {
  computed: {
    show() {
      for (let idx = 0; idx < this.bcSelectedStore.listSelected.length; idx++) {
        const element = this.bcSelectedStore.listSelected[idx];
        if (element.waiting > 0) {
          return true
        }
      }

      return false
    },
    ...mapStores(useBcSelectedStore)
  },
  methods: {
    async click() {
      this.loading = true
      const postData = {}
      this.bcSelectedStore.listSelected.forEach((selected) => {
        if (!selected.waiting) {
          return
        }

        if (!postData[selected.type]) {
          postData[selected.type] = []
        }

        postData[selected.type].push(selected.id)
      })

      await NetteAjax.post({
        url: this.$presenter.sendRequestLink,
        onSuccess: (data) => {
          this.bcSelectedStore.resetSelected()
          Toast(
            'success',
            this.$t('%cnt% approval requests sent', { cnt: data.sent })
          )
        },
        onError: () => {
          this.bcSelectedStore.resetSelected()
          Toast(
            'error',
            this.$t('Sending request for approvers failed')
          )
        },
        off: ['vue-render', 'vue-router']
      }, postData)

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
